import React, {useEffect} from 'react';
import Grid from "@material-ui/core/Grid";
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import {withRouter} from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import agreeData from "../../data/agreeData";
import client from "../../lib/api/client";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {answerState, menuCheckSelector, selectedMenuItemState, userState} from "../../state/globalState";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    formControlLabel: {
        fontFamily: 'Noto Sans KR',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '15px'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        borderRadius: 15,
        backgroundColor: "#1b6817",
        padding: '5px 30px',
        height: 35,
        fontSize: "15px",
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
            color: '#ffffff'
        }
    },
    textSecondary:{
        color: '#777',
        paddingLeft: 20
    },
}));

const AccordionForm = ({ history }) => {
    const userInfo = useRecoilValue(userState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const classes = useStyles();
    const [allCheck, setAllCheck] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [sentences, setSentences] = React.useState("");

    useEffect(() => {
        const TIME_ZONE = 3240 * 10000;
        const d = new Date();
        const date = new Date(+d + TIME_ZONE).toISOString();

        setAnswer({
            ...answer,
            svySttDate: date
        })

    }, []);

    useEffect(() => {
        if (userInfo.admnNo) {
            // let tmp = "<h3 style='text-align: center'>$stdYear$년 귀속 종합소득세 신고 질문지</h3>" +
            //     "해당 질문지는 $stdYear$년 귀속 종합소득세 신고를 위한 정보 수집 목적으로 사용되며, 이를 통하여 제공된 정보를 바탕으로 $stdYear$년 귀속 종합소득세 신고를 진행할 예정입니다.<br/><br/>" +
            //     "해당 질문지를 작성하실 때 $stdYear$년도 1월부터 12월까지에 해당하는 내용을 작성해 주시기 바랍니다.<br/><br/>" +
            //     "해당 질문지를 작성하시기 전에 서비스 진행을 위한 동의서 작성이 필수적으로 요구되므로, 아래 동의서를 확인 후 동의하여 주시기 바랍니다.<br/><br/>" +
            //     "EY는 제공된 정보의 진위여부를 검토하지 않기 때문에 해당하는 항목에 대하여 정확하게 작성해 주시기 바랍니다.<br/><br/>" +
            //     "작성된 정보에 대한 사실책임은 귀하에게 있음을 유념해 주십시오. 작성된 내용을 바탕으로 신고서 작업이 완료된 후 수정사항 등 변동이 있는 경우에는 귀하 및 회사에 추가적인 비용이 발생할 수 있습니다.<br/><br/>" +
            //     "질문지를 제출하지 않거나, 일부만 작성하고 제출해 주시는 경우, 종합소득세 신고진행이 지연될 수 있습니다. 이러한 경우 추가적인 비용이 귀하 및 회사에 발생할 수 있습니다. 또한 공제자료 등이 불충분한 경우에는 소득공제를 적용할 수 없기 때문에 과중한 세금이 부과될수도 있습니다.<br/><br/>" +
            //     "저희 EY한영에서는 한국 종합소득세 신고에 대한 서비스를 제공해 드리고 있으며, 그 이외에 세무신고(양도소득세, 상속세 및 증여세, 해외금융계좌 신고, 해외부동산 투자운용 명세서) 에 대해서는 제공해 드리지 않습니다. 이에, 해당사항이 있으신 경우 개인적으로 과세당국에 신고하셔야 하는 점 참고부탁드립니다.<br/><br/>" +
            //     "질문지 작성과 관련하여 궁금하신 부분이 있으시면 질문지 상 <span style='font-weight: bold'>1:1 문의사항</span> 을 통해 질문 기재부탁드립니다.<br/><br/>" +
            //     "협조해 주셔셔 감사드립니다.";
          let tmp = "<h2 style='text-align: center'>$stdYear$년 귀속 종합소득세 신고 질문지</h2><br/>" +
            "귀하는 회사의 결정에 따라 대상자로 선정되어 저희 EY에서 귀하를 대신하여 종합소득세 신고서를 준비 및 신고하게 되었습니다.<br/><br/>" +
            "다음의 경우에 해당하는 자는 연말정산을 하였더라도 종합소득세 신고의무가 있습니다.<br/>" +
            "&nbsp;&nbsp;&nbsp;-\t연말정산 합산신고를 진행한 근로소득 이외에 다른 이자∙배당∙사업∙연금∙기타소득이 있는 자<br/>" +
          "&nbsp;&nbsp;&nbsp;-\t2개 이상의 회사에서 받은 근로소득을 연말정산을 통해 합산하지 않은 자<br/>" +
            "&nbsp;&nbsp;&nbsp;-\t해외에 소재한 회사에서 근무하고 받은 근로소득이 있는 자<br/>" +
            "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(실제 지급된 급여만 아니라 주식보상소득, 비현금성 혜택, 세금지원 등을 포함함.)<br/><br/>" +
            "해당 질문지는 $stdYear$년 귀속 종합소득세 신고를 위한 정보수집 목적으로 요청되었으며, 귀하께서 제공해주신 정보를 바탕으로 $stdYear$년 귀속 종합소득세 신고서가 준비 및 신고됩니다.<br/><br/>" +
            "작성하실 때 유의하셔야 하는 부분을 다음과 같이 안내 드립니다.<br/>" +
            "&nbsp;&nbsp;&nbsp;<b>-\t 동의서의 작성</b>\t: EY의 서비스 진행을 위해, 아래의 동의서를 확인하신 후 동의하여 주시기 바랍니다.<br/>" +
          "&nbsp;&nbsp;&nbsp;<b>-\t 작성기준</b>\t: 해당 질문지를 작성하실 때는 $stdYear$년도 1월부터 12월까지에 해당하는 내용을 작성해 주시기 바랍니다.<br/>" +
            "&nbsp;&nbsp;&nbsp;<b>-\t 진위판단의 책임</b>\t: EY는 제공된 정보의 진위(사실)여부를 검토하지 않습니다. 질문에 대하여 적확한 답변을 작성하여 주시기 바랍니다.<br/>" +
            "&nbsp;&nbsp;&nbsp;<b>-\t 자료제출의 책임</b>\t: 작성된 정보 및 관련 자료의 제공에 대한 책임은 귀하에게 있음을 유념하여 주시기 바랍니다.<br/>" +
            "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EY에서는 기한 내에 해당 질문지를 통해 제공해주신 정보 및 자료를 활용하여 종합소득세 신고를 준비하므로,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;적확한 자료를 적시에 제공하지 않는 경우 과중한 세금이 부과될 수도 있습니다.<br/>" +
            "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EY에서 신고서 작업이 완료된 후 수정사항 등 변동이 있는 경우에는 귀하 및 회사에 추가적인 비용이 발생할 수 있습니다.<br/><br/>" +
            "저희 EY한영에서는 회사와의 계약에 따라 한국 종합소득세 신고에 대한 서비스만 제공해 드리고 있으며, 그 밖의 세무신고(양도소득세, 상속세 및 증여세, 해외금융계좌 신고, 해외부동산 투자운용 명세서 등)에 대해서는 제공해 드리지 않습니다. 이러한 세무신고를 신고하실 책임이 있는 경우 개인적으로 과세당국에 신고하셔야 하는 점 참고 부탁드립니다.<br/><br/>" +
            "$stdYear$년 귀속 종합소득세 신고 준비가 기한 내에 수월하게 진행될 수 있도록 협조해 주심에 진심으로 감사드립니다.<br/><br/>" +
            "질문지 작성과 관련하여 궁금하신 부분이 있으시면 질문지 상 <b>1:1 문의사항</b> 을 통해 질문 부탁드립니다.<br/><br/>" +
            "감사합니다<br/>EY한영 배상";

            tmp = tmp.replace(/\$stdYear\$/gi, userInfo.stdYear);
            setSentences(tmp);
        }
    }, [userInfo]);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    useEffect(() => {
        if (answer[agreeData[0].column] === '1' && answer[agreeData[1].column] === '1' && answer[agreeData[2].column] === '1'
            && answer[agreeData[3].column] === '1' && answer[agreeData[4].column] === '1' && answer[agreeData[5].column] === '1'
            && answer[agreeData[6].column] === '1') {
            setAllCheck(true);

            setSelectedMenuItem('AGREE_0');
            setMenuCheck(true);
            // dispatch(changeState({
            //     key: 'AGREE_0',
            //     isChecked: true
            // }));

        } else {
            setAllCheck(false);

            setSelectedMenuItem('AGREE_0');
            setMenuCheck(false);

            // dispatch(changeState({
            //     key: 'AGREE_0',
            //     isChecked: false
            // }));
        }
    }, [answer])

    const onClickNextButton = (e) => {

        // 전체동의가 이루어져야 다음 단계로 넘어갈 수 있음
        if (answer[agreeData[0].column] === '1' && answer[agreeData[1].column] === '1' && answer[agreeData[2].column] === '1'
            && answer[agreeData[3].column] === '1' && answer[agreeData[4].column] === '1' && answer[agreeData[5].column] === '1'
            && answer[agreeData[6].column] === '1') {
            window.localStorage.setItem("previousLocation", "/agree");
            // dispatch(
            //     changeStep({
            //         step: 0
            //     })
            // );



            history.push('/survey');
            window.scrollTo(0, 0);
        } else {
            setAnchorEl(e.currentTarget);
        }
    };

    const onChangeCheckbox = (e) => {
        let columnName = "";
        const selectValue = e.target.checked ? '1' : '0';

        if (e.target.name === "chkAgreeOne") {
            columnName = [agreeData[0].column];
        } else if (e.target.name === "chkAgreeTwo") {
            columnName = [agreeData[1].column];
        } else if (e.target.name === "chkAgreeThree") {
            columnName = [agreeData[2].column];
        } else if (e.target.name === "chkAgreeFour") {
            columnName = [agreeData[3].column];
        } else if (e.target.name === "chkAgreeFive") {
            columnName = [agreeData[4].column];
        } else if (e.target.name === "chkAgreeSix") {
            columnName = [agreeData[5].column];
        } else if (e.target.name === "chkAgreeSeven") {
            columnName = [agreeData[6].column];
        }

        const newState = {
            ...answer,
            [columnName]: selectValue
        }

        setAnswer(newState);
    }

    const checkAllHandler = (e) => {
        const checkVal = e.target.checked ? "1" : "0";
        const newState = {
            ...answer,
            [agreeData[0].column]: checkVal,
            [agreeData[1].column]: checkVal,
            [agreeData[2].column]: checkVal,
            [agreeData[3].column]: checkVal,
            [agreeData[4].column]: checkVal,
            [agreeData[5].column]: checkVal,
            [agreeData[6].column]: checkVal
        }

        setAnswer(newState);
    }

    return (
        userInfo.admnNo &&
        <React.Fragment>
            <Grid container
                  direction="column"
                  alignItems="flex-start"
                  justifyContent="center"
            >
                <div className={classes.root}>
                    <div>
                        <div dangerouslySetInnerHTML={ {__html: sentences} } />
                    </div>
                    <Divider />
                    <Button variant="contained" fullWidth={true}
                            style={{justifyContent: "flex-start", marginBottom: '20px', marginTop: '35px',
                                backgroundColor: '#1b6817', color: '#ffffff'}}>
                        <FormControlLabel
                            onChange={(event) => checkAllHandler(event)}
                            control={<Checkbox checked={allCheck} iconStyle={{fill: 'white'}} style={{color:'white'}} />}
                            label="모두 동의"
                        />
                    </Button>

                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions1-content"
                            id="additional-actions1-header"
                        >
                            <FormControlLabel
                                aria-label="Acknowledge"
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={<Checkbox name="chkAgreeOne" checked={answer.tosaAgreeYn === '1'} onChange={(e) => onChangeCheckbox(e)} />}
                                label={<Typography className={classes.formControlLabel}>Terms of Service Agreement 동의서</Typography>}
                            />
                        </AccordionSummary>
                        <AccordionDetails>
                            <Paper style={{maxHeight: 500, overflow: 'auto', padding: '0 20px 20px 20px'}}>
                                    <h4>People Advisory Services 서비스에 관한 서비스 조건 동의서</h4>
                                    <h4>TERMS OF SERVICE AGREEMENT FOR PEOPLE ADVISORY SERVICES</h4>
                                    <ul  className={classes.textSecondary}>
                                        <li>People Advisory 서비스를 위한 서비스 조건에 관한 동의서에서 안내하는 바와 같이 Ernst & Young Han Young(이하 “EY”)는 {userInfo.corprName}와 용역계약을 체결하여 귀하에게 People Advisory 서비스를 제공하고자 합니다.</li>
                                        <li>본 서비스 조건 동의서는 EY가 귀하에게 제공하는 서비스 및 귀하의 고용주(이하 “고용주”)와 EY간의 계약 협정에 의한 서비스 수신자로써의 귀하의 책임과 관련 내용을 포함합니다.</li>
                                        <li>EY는 고용주의 People Advisory 프로그램에 의거하여 아래 서비스의 범위에 따른 특정 People Advisory 서비스를 귀하의 배우자 또는 다른 가족구성원(이하 “귀하”)에게 제공합니다.</li>
                                        <li>EY는 귀하의 고용주의 People Advisory 서비스 프로그램 하에서 고용주에게 다른 서비스를 제공할 수 있습니다. 귀하에게 제공하는 서비스를 포함하여 고용주의 People Advisory 서비스 프로그램 하에서 제공되는 모든 서비스를 총칭하여 이하 "서비스"라 합니다. </li>
                                        <li>People Advisory 서비스 프로그램의 내용은 EY과 귀하의 고용주 간의 계약에 의거합니다. 위 계약의 내용 중 귀하에게 제공되는 서비스와 관련된 내용은 아래와 같습니다. </li>
                                        <h4>[ EY 네트워크 ]</h4>
                                        <li>EY 한영은 EY Global Limited에서 총괄하는 글로벌 네트워크(이하 “EY Network”)의 회원사이며, 다른 회원사들과 마찬가지로 서로 독립된 별개의 법인입니다. EY 한영 이외 EY Network의 회원사는 EY가 귀하에게 제공하는 서비스와 관련한 어떠한 책임도 지지 않습니다. EY 한영은 EY Network에 속한 다른 회원사의 대리인이 아니며 다른 어떤 회원사도 EY 한영의 대리인이 아닙니다.</li>
                                        <li>EY 한영이 제공하는 서비스와 관련하여 귀하는 EY 한영만을 대상으로 클레임을 제기할 수 있으며, 본 서비스의 제공와 관련된 다른 어떠한 개인에 대하여 클레임을 제기하지 않는 것에 동의합니다.</li>
                                        <li>또한 귀하는 그 어떠한 관할 지역에서도 EY 한영 외 다른 EY Network 회원사 및 그 파트너, 직원에 대하여 법적 조치를 쥐하지 않을 것에 동의합니다.</li>
                                        <li>본 내용은 EY 한영을 포함한 EY Network 회원사 및 그 파트너, 직원을 위한 것으로, 이들에게 본 내용을 집행할 권한이 있습니다.</li>
                                        <h4>[ 세무 당국 공지 ]</h4>
                                        <li>귀하는 납세자로써 조세에 관한 법령을 준수할 의무가 있습니다. 본 의무사항에는 관련 법령에서 요구하는 자료 유지 및 정확하고 완전한 정보를 세무 당국에 제공하는 것이 포함됩니다. 관련 법령을 준수하지 아니할 경우 세무 당국으로부터 불이익을 부과받을 수 있습니다.</li>
                                        <h4>[ 전자 매체를 통한 (Electronic Means) 커뮤니케이션 ]</h4>
                                        <li>귀화와 서면으로 달리 합의되지 아니한 이상, EY은 귀하의 고용주와의 협의된 바와 같이 이메일을 비롯한 전자 매체를 통해 정보를 제공할 수 있습니다. 정보의 전자적 전송과 관련된 고유의 위험으로 인해 우리의 방화벽(firewall)으로 보호 불가능한 모든 정보의 기밀성과 무결성을 보장해드리기 어렵습니다. 또한 EY 정책상 안티바이러스 소프트웨어가 사용되지만 모든 전자 정보 및 그 전송의 무결성을 보장해드리기 어렵습니다.</li>
                                        <h4>[ 기술의 이용 조항 ]</h4>
                                        <li>EY는 원활한 상호 정보/서류 교환을 위해 귀하에게 우리의 독점적인 소프트웨어 도구인 EY GlobalOne에 대한 접근을 제공할 수 있습니다. 귀하는 오프라인 캘린더 응용 프로그램 및 Microsoft Excel 오거나이저(이하 "소프트웨어")를 다운로드하고 사용할 수 있는 권한을 받게 될 수 있습니다. 이러한 경우, 소프트웨어에 대한 접근과 사용은 EY GlobalOne 사이트 상 규정된 조항 및 조건이 적용됩니다.</li>
                                        <h4>[ 서비스의 제공 ]</h4>
                                        <li>EY가 귀하에게 서비스를 제공하기 위하여, 귀하는 EY가 귀하의 개인소득과 세금환급 자료등의 관련 자료들(이하 “데이타”)을 요구할 경우 정확하고 시기적절하게 이를 제공할 것에 동의합니다. 또한 귀하는 귀하의 고용주가 EY에게 데이타를 제공하기 위한 권한을 부여하였다는 것을 확인하고 보증합니다.</li>
                                        <li>귀하의 고용주가 다른 서비스 제공자로부터 EY에게 서비스제공에 대한 권한을 양도하였을 경우, 서비스 제공을 위한 귀하의 데이타 교환을 위해 EY이 이전 서비스 제공 업체와 연락할 수 있으며 이러한 절차를 진행하기 위해 필요한 의사표시를 하는 것에 대해 동의합니다.</li>
                                        <li>EY가 제공하는 세무 자문에 관한 정보에는 EY 대내 또는 대외적 커뮤니케이션 및 세무 자문 제공 과정에서 생성된 모든 자료가 포함되며, 일부 관할 지역에서는 본 세무 자문에 관한 정보에 대해 관할 세무 당국을 상대로 공개되지 아니할 비밀유지 특권 또는 보호 대상이 될 수 있습니다(이하 “비닉특권”). 관할 세무 당국에서 EY 또는 귀하에게 이러한 정보의 공개를 요구할 경우 EY는 가능한 범위내에서 귀하의 비닉특권의 행사, 포기 등에 대해 귀하와 의논할 것입니다.</li>
                                        <h4>[ 서비스의 범위 ]</h4>
                                        <li>EY와 귀하의 고용주 간의 계약 조건에 따라 EY는 부록 1에 규정된 서비스 중 귀하가 선택한 서비스를 제공할 것입니다. 이러한 서비스는 EY와 귀하의 고용주간의 협의에 따라 귀하의 고용주가 필요하다고 결정한 서비스만을 포함합니다. 계약 기간 동안 수시로 본 서비스는 변경될 수 있습니다. 이러한 변경이 귀하에게 적용될 경우 관련 사항에 대해 통지해 드리겠습니다.</li>
                                        <li>EY는 귀하의 고용주와 데이타의 수집, 처리 및 서비스의 제공 방법에 대해 상호 합의하였습니다.</li>
                                        <li>귀하가 부록 1에 포함되지 않은 서비스에 대한 도움이 필요하다면 저희와 의논하여 주십시오. 의논 후 필요할 경우에 한해 EY는 본 서비스 범위 이외의 제공에 대한 승인을 위해 귀하의 고용주에게 연락하거나 귀하와 별도로 계약을 체결할 수 있습니다. 보다 자세한 정보가 필요할 경우 귀하의 고용주나 EY의 관련 담당자에게 연락하십시오.</li>
                                        <h4>[ 책임의 제한 ]</h4>
                                        <li>귀하(본 서비스를 제공받는 타인 포함)는 본 계약 또는 서비스에 관련하여 이익상실, 데이터 손상, 또는 기타 특별손해에 대해  EY에게 어떠한 책임도 묻지 아니합니다. 본 조는 EY가 이 위와 같은 손실 내지 손해의 발생가능성을 알았거나 알 수 있었는지 여부를 불문하고 적용됩니다.</li>
                                        <li>본 계약 또는 서비스와 관련하여 EY의 채무불이행이나 불법행위로 인해 귀하(본 서비스를 제공받는 타인 포함)에게 발생한 손해에 대한 EY의 배상책임은 EY가 지급받은 용역보수의 ( 1 )배를 한도로 합니다.</li>
                                        <li>만일 본 계약 또는 서비스에 관하여 EY가 귀하(본 서비스를 제공받는 타인 포함)에게 부담하는 손해배상책임에 제3자가 기여한 부분이 있을 경우, EY는 제3자와 연대하여 귀하에게 책임을 부담하지 아니하며 발생한 총 손해액 중 EY가 기여한 책임범위에 한하여 배상책임을 부담합니다. 또한 다음 (1) 내지 (4)의 사항은 EY가 기여한 책임범위를 산정함에 있어 어떠한 영향도 미치지 아니합니다.</li>
                                        <ol>
                                            <li>상호합의나 법률에 의해 제3자의 손해배상책임이 제한되거나 면제되는 경우</li>
                                            <li>제3자가 제기한 클레임이 종결되거나, 제3자를 상대로한 클레임을 제기하는 것이 사실상 불가능한 경우</li>
                                            <li>제3자가 사망 또는 해산하거나 지급불능 상태에 빠지는 경우</li>
                                            <li>제3자의 손해배상책임이 소멸하는 경우</li>
                                        </ol>
                                        <li>본 계약 또는 서비스에 관한 클레임은 서비스 완료일 부터 5년 이내에 제기되어야 합니다.</li>
                                        <li>책임 제한에 관한 상기 17조 및 19조는 EY의 고의나 기망행위로 인해 발생한 손해와, 관련 법령이나 전문가 규정에 의해 금지된 경우에는 적용되지 아니합니다.</li>
                                        <li>귀하는 EY 한영만을 대상으로 본 계약 또는 서비스와 관련하여 발생하는 클레임을 제기하거나 법적 조치를 취할 수 있으며, (1) 다른 EY 회원사와 (2) 다른 EY 회원사 또는 EY 한영의 사원, 주주, 임직원(통칭하여 이하 “EY임직원”)을 대상으로는 클레임을 제기하거나 법적 조치를 취할 수 없습니다.</li>
                                        <h4>[ 준거법 ]</h4>
                                        <li>본 계약 및 서비스와 관련한 의무사항은 대한민국 법률에 따라 해석되고 규율됩니다.</li>
                                        <h4>[ 분쟁 해결 ]</h4>
                                        <li>본 계약이나 서비스와 관련된 모든 분쟁은 서울 중앙 지방 법원이 전속적으로 관할합니다.</li>
                                        <h4>[ 본 서비스 조건에 대한 동의 ]</h4>
                                        <li>본 서비스 조건은 귀하의 전자적 승인일로부터 발효됩니다. 귀하는 귀하의 배우자 또는 다른 가족 구성원을 대신하여 본 서비스 조건에 동의할 권한이 있음을 확인하고 보증합니다.</li>
                                        <h4>[ 부록 1 ]</h4>
                                        <h5>{userInfo.corprName}</h5>
                                        <h4>[ 서비스의 범위 ]</h4>
                                        <li>사용 가능한 서비스는 다음과 같으며, EY와 협의하여 사업주에 의해 결정하는 경우에만 직원에 제공될 수 있다.</li>
                                        <span>- 한국 세무 서비스</span><br/>
                                        <span>- 한국 소득신고서 준비와 보조 서비스</span><br/>
                                        <span>- 종합소득세 신고서 준비</span><br/>
                                        <span>- 수정 종합소득세 신고서 준비 (필요시)</span><br/>
                                        <span>- 종합소득세 신고의무에 대한 판단</span><br/>
                                        <span>- 가상세액정산 (Tax equalization)</span><br/>
                                        <h4>[ 제공되지 않는 서비스 ]</h4>
                                        <li>저희 서비스에 포함되는 항목에 대한 이해를 돕기 위해, 제공되지 않는 서비스의 예를 보시길 권장합니다.</li>
                                        <span>- 양도소득세 신고</span><br/>
                                        <span>- 퇴직소득세 신고</span><br/>
                                        <span>- 해외금융계좌 신고</span><br/>
                                        <span>- 해외부동산 신고</span><br/>
                                        <span>- 예상소득세 계산</span><br/>
                                        <span>- 은행 보고용 서식</span><br/>
                                        <span>- 자녀나 그외의 부양가족, 가사도우미등의 소득세신고</span><br/>
                                        <span>- 증여세 또는 부동산세 신고</span><br/>
                                        <span>- 신탁, 파트너십 또는 기업소유권 신고</span><br/>
                                        <span>- 소득세 신고를 위한 특정 정보수집(부동산/증권 거래)을 위해 제 3자(공인중개사, 대리인, 중개인등)에게 연락하는 행위</span><br/>
                                        <span>- 보험, 금융, 부동산, 은퇴설계</span><br/>
                                        <span>- 개인을 위한 세금설계</span><br/>
                                        <span>- 재무/투자상담</span><br/>
                                    </ul>
                            </Paper>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions2-content"
                            id="additional-actions2-header"
                        >
                            <FormControlLabel
                                aria-label="Acknowledge"
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={<Checkbox name="chkAgreeTwo" checked={answer.dpcnAgreeYn === '1'} onChange={(e) => onChangeCheckbox(e)} />}
                                label={<Typography className={classes.formControlLabel}>Data Privacy Consent Notice 동의서</Typography>}
                            />
                        </AccordionSummary>
                        <AccordionDetails>
                            <Paper style={{maxHeight: 500, overflow: 'auto', padding: '0 20px 20px 20px'}}>
                                    <ul  className={classes.textSecondary}>
                                        <li>People Advisory 서비스를 위한 정보 보호에 관한 동의서에 따라 Ernst & Young 멤버회사는 귀하에게 People Advisory 서비스를 제공할 것이며, 전세계 Ernst & Young 조직(이하 Ernst & Young) 도 달리 합의되지 않는 한 귀하에게 서비스를 제공할 수 있습니다.</li>
                                        <li>Ernst & Young 은 귀하, 가능한 경우 귀하의 배우자, 가족 및 그와 동등한 위치에 있는 대상자를 위해 귀하의 고용주와의 계약서상에 명시되어 있고 People Advisory 서비스 프로그램 하에 있는 특정 서비스를 수행할 것입니다. 귀하에게 제공되는 서비스의 범위는 귀하 또는 귀하의 고용주, Ernst & Young 에 의해 논의된 후 귀하에게 안내될 것입니다.</li>
                                        <li>Ernst & Young 은 또한 귀하의 고용주의 People Advisory 서비스(이하 “서비스”) 프로그램 하에 있는 특정 서비스를 귀하의 고용주에게 제공할 수 있습니다.</li>
                                        <li>귀하와 귀하의 고용주에게 특정 People Advisory 서비스（이하 "서비스"）를 제공하기 위하여, Ernst & Young은 귀하의 정치적 의견, 종교적 신념, 노동 조합 구성원, 신체 또는 정신 건강, 성생활, 형사 소송, 주민등록번호 또는 기타 정부 발급 개인식별 번호, 납세신고서 기입과 관련된 금융 계좌 정보와 같은 민감한 개인 정보들을 다루게 됩니다. 이러한 과정에서 Ernst & Young 은 개인정보 보호에 관한 법령과 자사의 개인정보 보호 정책을 준수 할 것입니다.</li>
                                        <li>EU 내 위치한 Ernst & Young 멤버 법인을 통하여 제공되는 서비스 또는 Ernst & Young이 EU 내 제공하는 서비스에 관하여, Ernst & Young은 European Union Directive – 95/46/EC 에서 규정하는 Data Controller를 지정할 것입니다. Data Controller는 Ernst & Young 멤버 법인 중의 하나로서 귀하와 귀하의 고용주에 대해 서비스를 제공하기 위한 목적으로 귀하의 개인정보를 처리할 수 있습니다.</li>
                                        <li>귀하의 개인정보 처리를 중지하기를 원하신다면 귀하의 이름, 주소, 고용주의 이름을 제공하여 Ernst & Young 담당자에게 연락하시기 바랍니다.</li>
                                        <li>귀하에게 서비스를 제공함에 있어서, Ernst & Young 은 EU 외 위치한 국가를 포함한 다른 국가의 Ernst & Young 회원사간에 귀하의 개인 정보를 전송할 수 있습니다. 이는 품질을 유지하고 고용주와 계약이 요구하는 대로 효율적인 서비스를 제공하기 위한 것입니다. 개인정보 보호에 관한 법령은 관할지역에 따라 다를 수 있지만 Ernst & Young 은 전세계 모든 회 원사가 Ernst & Young 내규에 따른 귀하의 비밀 및 보안에 관한 정책을 준수할 것을 요구하며, 또한 Ernst & Young 은 귀하의 개인정보에 대한 무단 접근, 사용, 공개를 방지하기 위한 보안 시스템을 사용합니다. 귀하의 개인정보에 대한 Ernst & Young 의 처리와 보호에 대한 보다 자세한 내용을 원하거나 귀하의 개인 정보에 대한 접근 또는 수정을 원할 경우 귀하의 Ernst & Young 담당자와 연락하시기 바랍니다.</li>
                                        <h4>[ 동의서（Consent) ]</h4>
                                        <li>귀하와 귀하의 고용주에게 서비스를 제공하기 위해 필요한 한도 내에서, 귀하는 Ernst & Young 에 아래의 권한을 부여합니다:</li>
                                    </ul>
                                    <ul  className={classes.textSecondary}>
                                        <ol type="A">
                                            <li>귀하 또는 귀하의 고용주로부터 귀하의 개인정보(예 : 급여정보, 이하 “정보”）를 제공받을 권한</li>
                                            <li>귀하의 정보를 아래 대상자에 대하여 공개할 권한</li>
                                        </ol>
                                        <ul type="none">
                                            <li>가) 귀하의 고용주 또는 지정된 대리인</li>
                                            <li>나) (적용해야할 경우) 귀하의 배우자와 다른 가족 구성원</li>
                                            <li>다) 관계 당국 (과세 당국 혹은 출입 국사무소 포함)</li>
                                            <li>라) Ernst & Young 품질 검토팀 등을 포함한 다른 Ernst & Young 회원사</li>
                                            <li>마) Ernst & Young의 지시에 따라서만 정보를 공개할 수 있고 계약상 비밀유지의무를 지닌 제3의 서비스 제공자</li>
                                        </ul>
                                        <ol type="A">
                                            <li>정보 전송 계약, 정보 보안 규정 등 적절한 절차를 통해서 Ernst & Young이 적합한 수준의 정보보호를 확신할 수 있는 경우 유럽 연합(EU) 외부로의 정보 전송, 처리 그리고 보관 권한</li>
                                            <li>서비스 해지 후 관련 법령 및 전문가 기준에 따라 문서정보를 보관할 권한</li>
                                            <li>Ernst & Young의 서비스 품질향상을 위해 서비스에 대한 귀하의 피드백을 요청할 목적으로 고용한 타 리서치 기업(계약에 따른 정보 비밀유지의무를 지님)에 귀하의 개인 연락 정보 제공 권한</li>
                                        </ol>
                                    </ul>
                                    <ul className={classes.textSecondary}>
                                        <li>위의 B-가 항에 대한 귀하의 동의는 귀하와 귀하의 고용주에게 서비스를 제공하기 위한 목적으로만 사용되며, 세금 보전 계산 등에 대한 설명이 꼭 필요할 경우에는 고용과 무관한 자료를 포함할 수 있습니다.</li>
                                        <li>이 동의서는 귀하의 고용주와 Ernst & Young 사이에 체결된 서비스 계약에 명시된 국가의 법률에 따라 해석 및 적용됩니다.</li>
                                        <li>귀하가 귀하의 가족이나 배우자와 관련된 개인 자료를 Ernst & Young 에게 제공하는 경우, 본 동의서의 조건에 의하여 허용되고 준수하는 한도 내에서 Ernst & Young 이 귀하의 가족이나 배우자의 민감한 개인 정보를 처리할 가능성을 귀하가 명시적으로 통보하고 잠재적 처리에 필요한 모든 동의 또는 권한을 귀하가 수령 또는 위임 받았음을 의미하는 것으로 간주됩니다.</li>
                                        <li>귀하는 Ernst & Young 이 계약에 의거하여 본인에게 서비스를 제공하는 전 기간 동안 유효한 본 동의서의 내용을 확인하고 이견이 없다는 사실을 보증합니다.</li>
                                    </ul>
                            </Paper>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions3-content"
                            id="additional-actions3-header"
                        >
                            <FormControlLabel
                                aria-label="Acknowledge"
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={<Checkbox name="chkAgreeThree" checked={answer.requiredAgreeYn === '1'} onChange={(e) => onChangeCheckbox(e)} />}
                                label={<Typography className={classes.formControlLabel}>한국 개인정보보호법상 필수사항 동의</Typography>}
                            />
                        </AccordionSummary>
                        <AccordionDetails>
                                <ul className={classes.textSecondary}>
                                    <li>개인정보보호법상 (i) 고유식별정보의 처리, (ii) 민감정보의 처리, (iii) 제 3자에 대한 제공 및 공유의 3가지 사안에 대하여 동의 절차가 완료되어야 동 서비스 제공이 가능하오니 각각의 동의란에 동의 의사를 표시하여 주십시오.</li>
                                    <li>언스트앤영 한영회계법인 (EY Korea)</li>
                                    <h4>[ People Advisory 서비스를 위한 개인정보동의서에 대한 부록 ]</h4>
                                    <li>이 부록은 한영회계법인에 의한 개인 정보의 처리와 관련하여 추가적인 조항을 포함하고 있습니다. 이 부록은 People Advisory 서비스를 위한 개인정보동의서와 함께 참조되어야 하며, 조항의 불일치가 있을 경우 본 부록의 조건이 우선합니다.</li>
                                    <li>본인은 한영회계법인이 본인의 개인정보를 아래 기재한 바와 같이 취급한다는 사실을 고지받았으며, 이에 동의하는 뜻으로 본인의 성명을 기재하고 서명합니다. 또한 본인은 본 동의서에 동의하지 아니할 권리가 있음을 고지받았음을 확인합니다.</li>
                                </ul>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions3-content"
                            id="additional-actions3-header"
                        >
                            <FormControlLabel
                                aria-label="Acknowledge"
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={<Checkbox name="chkAgreeFour" checked={answer.kdpcUniIdentAgreeYn === '1'} onChange={(e) => onChangeCheckbox(e)} />}
                                label={<Typography className={classes.formControlLabel}>고유식별정보의 처리에 대한 동의</Typography>}
                            />
                        </AccordionSummary>
                        <AccordionDetails>
                                <ul className={classes.textSecondary}>
                                    <li>한영회계법인은 본인 식별 및 세무신고서 작성, 출입국 관련 비자업무, 국민연금가입증명서 발급 신청 등 4대보험관련 업무, 과세판정 대응 등을 목적으로 고유신별정보(주민등록번호/여권번호/외국인등록번호)를 수집하고 이용합니다.</li>
                                    <li>고유식별정보는 한영회계법인이 해당 정보를 제공받은 날이 속한 연도의 다음연도 첫날부터 기산하여 7년이 되는 날까지 보관되며 고유식별정보의 처리에 부동의할 수 있으나, 이 경우 세무 및 출입국 관리상 불이익이 있거나, 한영회계법인의 서비스를 제공받지 못할 수 있습니다.</li>
                                    <li>위 고유식별정보의 처리에 대해 동의합니다.</li>
                                </ul>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions3-content"
                            id="additional-actions3-header"
                        >
                            <FormControlLabel
                                aria-label="Acknowledge"
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={<Checkbox name="chkAgreeFive" checked={answer.kdpcSstiIntoAgreeYn === '1'} onChange={(e) => onChangeCheckbox(e)} />}
                                label={<Typography className={classes.formControlLabel}>민감정보의 처리에 대한 동의</Typography>}
                            />
                        </AccordionSummary>
                        <AccordionDetails>
                                <ul className={classes.textSecondary}>
                                    <li>
                                        한영회계법인은 연말정산 및 세무신고서 작성 목적으로 장애 유무에 관한 정보를 제공받을 수 있습니다.
                                    </li>
                                    <li>
                                        민감정보의 보유 및 이용 기간은 한영회계법인이 해당 정보를 제공받은 날이 속한 연도의
                                        다음연도 첫날부터 기산하여 7년이 되는 날까지이며, 민감정보의 처리에 부동의할 수 있으나
                                        이 경우 세무 및 출입국 관리상 불이익이 있거나, 한영회계법인의 서비스를 제공받지 못할 수 있습니다.
                                    </li>
                                    <li>위 민감정보의 처리에 대해 동의합니다.</li>
                                </ul>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions3-content"
                            id="additional-actions3-header"
                        >
                            <FormControlLabel
                                aria-label="Acknowledge"
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={<Checkbox name="chkAgreeSix" checked={answer.kdpcOtherAgreeYn === '1'} onChange={(e) => onChangeCheckbox(e)} />}
                                label={<Typography className={classes.formControlLabel}>제3자에 대한 제공 및 공유에 대한 동의</Typography>}
                            />
                        </AccordionSummary>
                        <AccordionDetails>
                                <ul className={classes.textSecondary}>
                                    <li>
                                        한영회계법인은 Ernst & Young Global Limited 의 member firm 으로서 member firm
                                        상호간의 업무 교류를 통한 글로벌 계약의 이행, 과세관청 및 출입국관리소 요청에 대한
                                        대응 목적으로 귀하의 성명, 주민등록번호/외국인등록번호/여권번호, 주소, 전자우편,
                                        전화번호, 국적, 성별, 소속, 직급, 사원번호, 여권정보, 가족정보, 학력, 경력,
                                        급여정보, 개인 소득, 자산 정보, 장애 여부, 입사일 및 퇴직일을 다른 Ernst & Young
                                        member firm (http://www.ey.com 참조), 과세관청, 출입국관리소와 공유할 수 있습니다.
                                    </li>
                                    <li>
                                        해당 정보는 한영회계법인이 해당 정보를 제공받은 날이 속한 연도의 다음연도 첫날부터
                                        기산하여 7년이 되는 날까지 공유되며, 개인정보의 제3자 제공에 부동의할 수 있으나
                                        이 경우 세무 및 출입국 관리상 불이익이 있거나 Ernst & Young member firm 의 본국 및
                                        주재국에서의 서비스에 제한이 있을 수 있습니다.
                                    </li>
                                    <li>위 제3자에 대한 제공 및 공유(국내 및 국외) 에 동의합니다.</li>
                                </ul>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions3-content"
                            id="additional-actions3-header"
                        >
                            <FormControlLabel
                                aria-label="Acknowledge"
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={<Checkbox name="chkAgreeSeven" checked={answer.dptyYn === '1'} onChange={(e) => onChangeCheckbox(e)} />}
                                label={<Typography className={classes.formControlLabel}>{userInfo.stdYear}년 귀속 종합소득세(지방소득세 포함) 대리신고 동의여부</Typography>}
                            />
                        </AccordionSummary>
                        <AccordionDetails>
                                <ul className={classes.textSecondary}>
                                    <li>주재원님의 종합소득세 신고서 검토를 거친 후에 납세의무자인 주재원님을 대신하여 법정신고기한인 5월 31일 이전에 저희 EY한영회계법인에서 주재원님의 주소지 관할 세무서와 지방자치단체에 적시 신고하여줄 것을 요청하는지 여부를 표기하여 주십시요.</li>
                                </ul>
                        </AccordionDetails>
                    </Accordion>
                </div>

                <Grid container
                      spacing={0}
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                >
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        id='next'
                        name='next'
                        value='next'
                        onClick={onClickNextButton}
                    >
                        다음
                    </Button>

                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <Typography className={classes.typography}>서비스 제공을 위해서 이용 약관에 동의 하시기 바랍니다.</Typography>
                    </Popover>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default withRouter(AccordionForm);
